export default () => ({
  currentUser: null,
  authenticated: false,
  accessConfirmed: null,
});
